/* DefaultColumnComponent.js */

"use strict";

const EventEmitter = require('events').EventEmitter;
// const _ = require('lodash');
const Renderer = require("./DefaultColumnRenderer");

class DefaultColumnComponent extends EventEmitter {

    constructor(value) {
        super();

        this._value = value;
        this._tooltip = value;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setValue(newVal){
        this._value = newVal;
        this.emit('Value', this._value);
        return this;
    }
    getValue(){
        return this._value;
    }

    setTooltip(newVal){
        this._tooltip = newVal;
        this.emit('Tooltip', this._tooltip);
        return this;
    }
    getTooltip(){
        return this._tooltip;
    }

    static SortFunction(a, b){
        let aVal = a[1], bVal = b[1];

        if (aVal > bVal) { return 1; }
        if (aVal < bVal) { return -1; }
        return 0;
    }
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DefaultColumnComponent;